interface LoadingStateProps {
    message?: string;
    fullScreen?: boolean;
    spinnerSize?: 'small' | 'medium' | 'large';
}

export default function LoadingState({
                                         message = "Lade Daten...",
                                         fullScreen = true,
                                         spinnerSize = 'medium'
                                     }: LoadingStateProps) {
    const sizeClasses = {
        small: 'w-8 h-8 border-3',
        medium: 'w-16 h-16 border-4',
        large: 'w-24 h-24 border-6'
    };

    const content = (
        <div className="text-center animate-fadeIn">
            <div className={`${sizeClasses[spinnerSize]} border-gray-300 border-t-green-500 rounded-full animate-spin mx-auto mb-6`}></div>
            <p className="text-gray-600">{message}</p>
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-white/90 backdrop-blur-sm z-50">
                {content}
            </div>
        );
    }
    return content;
}